//@flow
import api from '../Utils/apiBuilder';
import Constants from '../constants';

export default {
  getCategories() {
    return api('categories').noauth().get().dispatch(Constants.GET_CATEGORIES_SUCCESS);
  },
};
